export default __webpack_public_path__ + "static/media/file1.aca3fc5f.jpg";